import React, { useEffect, useState } from "react";
import { Instagram, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { SITE } from "../data/mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_POSTS = [
  { src: "/images/gym/race-haybales.jpg", alt: "Boston Iron Grit athletes competing at an outdoor throwdown" },
  { src: "/images/gym/db-snatch.jpg", alt: "Member pressing a dumbbell overhead" },
  { src: "/images/gym/pullup-woman.jpg", alt: "Member performing kipping pull-ups" },
  { src: "/images/gym/kb-swing.jpg", alt: "Member swinging a kettlebell" },
  { src: "/images/gym/wallball-coaching.jpg", alt: "Coach Miguel coaching wall balls" },
  { src: "/images/gym/hero-barbell.jpg", alt: "Member pulling a barbell in competition" },
];

export function InstaStrip() {
  const [live, setLive] = useState(null);

  useEffect(() => {
    fetch(`${API}/instagram/feed`)
      .then((r) => r.json())
      .then((d) => {
        if (Array.isArray(d.items) && d.items.length >= 3) setLive(d.items.slice(0, 6));
      })
      .catch(() => {});
  }, []);

  const posts = live
    ? live.map((p) => ({
        src: p.media_type === "VIDEO" ? p.thumbnail_url : p.media_url,
        alt: p.caption ? p.caption.slice(0, 100) : "Boston Iron Grit on Instagram",
        href: p.permalink,
        key: p.id,
      }))
    : FALLBACK_POSTS.map((p, i) => ({ ...p, href: SITE.social.instagram, key: p.src }));

  return (
    <section className="bg-[#0A0A0B] py-16 lg:py-20" data-testid="home-instagram">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div>
              <Eyebrow>The Community, Daily</Eyebrow>
              <h2 className="font-heading font-extrabold uppercase text-3xl lg:text-4xl text-white leading-[0.95] tracking-tight">
                Follow the grit.
              </h2>
            </div>
            <a
              href={SITE.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-btn"
              className="inline-flex items-center gap-2.5 self-start font-mono text-[12px] uppercase tracking-[0.16em] text-white border border-white/20 hover:border-[#9D0423] px-5 py-3 transition-colors"
            >
              <Instagram size={15} className="text-[#9D0423]" /> @crossfitbostonirongrit
            </a>
          </div>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2" data-testid={live ? "instagram-grid-live" : "instagram-grid-fallback"}>
          {posts.map((p, i) => (
            <Reveal key={p.key} delay={i * 60}>
              <a
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                className="relative block aspect-square overflow-hidden group bg-[#121214]"
                data-testid={`instagram-post-${i}`}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <Instagram size={22} className="text-white" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
        <div className="mt-8">
          <a
            href={SITE.social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-mono text-[12px] uppercase tracking-[0.16em] text-neutral-400 hover:text-white transition-colors"
          >
            See more on Instagram <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}
